import request from './request';

// 发表评论
export function publishComment(params) {
  return request('/comment', {
    method: 'POST',
    params,
  });
}
// 获取评论列表
export function getCommentList(params) {
  return request('/comment/list', {
    method: 'GET',
    params,
  });
}
// 评论点赞
export function commentLike(id) {
  return request(`/comment/like/${id}`, {
      method: 'POST'
  });
}
// 评论点踩
export function commentDislike(id) {
  return request(`/comment/dislike/${id}`, {
      method: 'POST'
  });
}
// 删除评论
export function deleteComment(id) {
  return request(`/comment/delete/${id}`, {
      method: 'DELETE'
  });
}